import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckRoundedIco = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM17.6729 7.92676C17.2642 7.55533 16.6313 7.58561 16.2598 7.99414L10.6357 14.1797L7.74023 10.9941C7.36878 10.5855 6.73581 10.5554 6.32715 10.9268C5.91851 11.2983 5.88831 11.9312 6.25977 12.3398L9.89648 16.3398C10.086 16.5482 10.3551 16.667 10.6367 16.667C10.9181 16.6668 11.1866 16.548 11.376 16.3398L17.7402 9.33984C18.1115 8.93123 18.0813 8.29823 17.6729 7.92676Z",
		fill: "currentColor"
	})
});
export default SvgCheckRoundedIco;
